import { BackButton } from '@library/buttons';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import AddFloorPlan from 'modules/site-walk/components/AddFloorPlan/AddFloorPlan';

const AddFloorPlanPage = () => {
    return (
        <PageTemplate>
            <PageHeading>
                <div>
                    <div>Add Floor Plan</div>
                    <BackButton className="mt-2" />
                </div>
            </PageHeading>

            <AddFloorPlan />
        </PageTemplate>
    );
};

export default AddFloorPlanPage;
